/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from 'react';
import {InnerVerticalTabs} from '../../../components/Tabs/InnerVerticalTabs/InnerVerticalTabs';
import {StringParam, useQueryParam} from "use-query-params";
import {useAppSelector} from '../../../../redux/hooks';
import {selectCurrentUser} from '../../../../redux/ducks/AccessControl/slice';
import {versionsTabUrlParam} from '../../objectApp/constants';
import {ETrackedItemTypes} from '../../../../constants/trackedItems';
import {useSetRecentlyViewedWithDeps} from '../../../../hooks/useSetRecentlyViewedWithDeps';
import MiscellaneousContent from './MiscellaneousContent';


const MiscellaneousObjectsDetailsTab = (props: any) => {
  const objectData = props.objectData
  const isCustomObject = props.isCustomObject
  const fetchBaselineData = props.fetchBaselineData
  const triggerReRender = props.triggerReRender
  const [tabs, setTabs] = useState<any>([])
  const [selectedTab, setSelectedTab] = useQueryParam(versionsTabUrlParam, StringParam)


  useEffect(() => {
    if (!objectData) return; // Early return if objectData is undefined or null

    const localTabs: any[] = [];
    let firstItemUid = '';

    // Process each item in objectData
    objectData.forEach((item: any, index: number) => {
      const trackedItemUid = item.id;
      const latestVersion = item.latestVersion;

      localTabs.push({
        "name": `Version ${latestVersion}`,
        trackedItemUid,
        "content": <MiscellaneousContent object={item} isLatestVersion={index == objectData.length - 1} fetchBaselineData={fetchBaselineData} triggerReRender={triggerReRender}/>
      });

      // Set the first item UID for initial tab selection
      if (!firstItemUid) {
        firstItemUid = trackedItemUid;
      }
    });

    if (isCustomObject) {
      // Handle custom object logic if necessary
    }

    // Set the first tab as selected only if the URL doesn't have the id param
    if (!selectedTab) {
      setSelectedTab(firstItemUid);
    }

    setTabs(localTabs);
  }, [objectData, fetchBaselineData, triggerReRender, selectedTab]);

  // Vertical Tab Section in View Details of a Potentially Moving Object
  return (<>
    <div style={{flexGrow: 1, display: 'flex', height: '100%'}}>
      {
        isCustomObject ? (tabs?.[0]?.content ?? null) :
          <InnerVerticalTabs
            tabs={tabs}
            favoriteType={ETrackedItemTypes.MISCELLANEOUS_OBJECTS}
            uid={versionsTabUrlParam}
            onTabSelected={(newValue: number) => {
              const selectedTabUid = tabs[newValue]?.trackedItemUid ?? 'baseline';
              setSelectedTab(selectedTabUid);
            }}
          />
      }
    </div>
  </>)
}
export default MiscellaneousObjectsDetailsTab